import { Modal } from "antd";
import React, { useState } from "react";
import { deleteComponent, deleteEmbedComponent } from "../../Utils/SupabaseServices/StayUpToDateDatabase";

const ComponentDeleteModal = (props: any) => {
  const {
    openDeleteModal,
    // handleOk,
    // handleCancel,
    // confirmLoading,
    selectedComponent,
    user_id,
    refetch,
    username,
    localData,
    setLocalData,
    setOpenDeleteModal,
    displayedItems,
    setDisplayedItems,
    from
  } = props;
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = async () => {
    setConfirmLoading(true);
    const newData = [...localData];
    const filteredData = newData.filter(
      (item) => item.name !== selectedComponent
    );
    const dataToDelete = newData.filter(
      (item) => item.name === selectedComponent
    );

    // Optimistically update the UI
    setLocalData(filteredData);
    if (displayedItems > filteredData.length) {
      setDisplayedItems(filteredData.length);
    }

    // Close modal and stop loading immediately after frontend update
    setConfirmLoading(false);
    setOpenDeleteModal(false);

    try {
      // Delete in background
      if (from === "embed-page") {
        await deleteEmbedComponent(
          selectedComponent,
          user_id,
          filteredData,
          dataToDelete,
          refetch,
          username
        );
      }else{
      await deleteComponent(
        selectedComponent,
        user_id,
        filteredData,
        dataToDelete,
        refetch,
        username
      );
    }
    } catch (error) {
      console.error("Error deleting component:", error);
      // If there's an error, revert the optimistic update
      setLocalData(newData);
      if (displayedItems > newData.length) {
        setDisplayedItems(newData.length);
      }
      // Refresh data to ensure correct state
      refetch();
    }
  };

  const handleCancel = () => {
    setOpenDeleteModal(false);
  };
  return (
    <Modal
      open={openDeleteModal}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Yes"
      confirmLoading={confirmLoading}
      focusTriggerAfterClose={false}
      getContainer={false}
    >
      <p className="alertText">
        You're about to delete the{" "}
        <span className="alertTextTitle">{selectedComponent}</span> section. Are you sure?{" "}
      </p>
    </Modal>
  );
};

export default ComponentDeleteModal;
